export default {
  diaryList: []
}
